import axios from "axios";
import { encryptCryptoJs } from "../../Helper/crypto";

export const apiLogin = async (payload) => {

  const cred = btoa(`${payload.login}:${payload.password}`); // string to base64

  const headers = { 'Authorization': `Basic ${cred}`, 'Content-Type': 'application/json' };

  try {

    const res = await axios.post(process.env.REACT_APP_URL_CREDENCIAL_LOGIN, null, {
      headers: headers,
      withCredentials: true
    });

    if (res.status === 200) {

      const LoginStringfied = JSON.stringify(res.data);
      const LoginEncrypted = await encryptCryptoJs(LoginStringfied);

      console.log('Sucesso API de Login');

      localStorage.setItem('RL774DLxRi9E', LoginEncrypted);

      return {status: 200, message: 'success'}; 
    } else {
      return {status: 500, message: 'error'}; 
    }

  } catch (error) {

    console.log('Erro sem resposta da API de Login');
  
    localStorage.removeItem('RL774DLxRi9E');

    return {status: 500, message: 'error'};
  }

};

